import { render, staticRenderFns } from "./CarrosellHome.vue?vue&type=template&id=1a07594e&scoped=true"
import script from "./CarrosellHome.vue?vue&type=script&lang=js"
export * from "./CarrosellHome.vue?vue&type=script&lang=js"
import style0 from "./CarrosellHome.vue?vue&type=style&index=0&id=1a07594e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07594e",
  null
  
)

export default component.exports